import React, { createContext, useContext, useEffect, useState } from "react";

const A11yCtx = createContext({});
export const useA11y = () => useContext(A11yCtx);

const DEFAULT_PREFS = {
  large: false,
  xlarge: false,
  highContrast: false,
  underlineLinks: false,
  lineHeight: false,
  noMotion: false,
  noBgVideo: false,
  strongFocus: false,
};

const KEY = "drb_a11y_prefs";

export function A11yProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    try { return { ...DEFAULT_PREFS, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; }
    catch { return DEFAULT_PREFS; }
  });

  useEffect(() => {
    const b = document.body;
    b.classList.toggle("a11y-large", prefs.large && !prefs.xlarge);
    b.classList.toggle("a11y-xlarge", prefs.xlarge);
    b.classList.toggle("a11y-high-contrast", prefs.highContrast);
    b.classList.toggle("a11y-underline-links", prefs.underlineLinks);
    b.classList.toggle("a11y-line-height", prefs.lineHeight);
    b.classList.toggle("a11y-no-motion", prefs.noMotion);
    b.classList.toggle("a11y-no-bg-video", prefs.noBgVideo);
    b.classList.toggle("a11y-strong-focus", prefs.strongFocus);
    localStorage.setItem(KEY, JSON.stringify(prefs));
  }, [prefs]);

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));
  const reset = () => setPrefs(DEFAULT_PREFS);

  return <A11yCtx.Provider value={{ prefs, toggle, reset }}>{children}</A11yCtx.Provider>;
}
